// i18n area 'auth' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.pl-PL.meta.json.
import type { enUS } from './auth'

export const plPL: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Zaloguj się na swoje konto',
    username: 'Nazwa użytkownika',
    usernamePlaceholder: 'Wpisz nazwę użytkownika',
    usernameHint: 'Użyj formatu użytkownik@domena, aby uwierzytelnić się w realm katalogowym',
    continue: 'Kontynuuj',
    changeUser: 'Zmień użytkownika',
    password: 'Hasło',
    forgotPassword: 'Nie pamiętasz hasła?',
    submit: 'Zaloguj się',
    otp: 'Kod jednorazowy',
    otpSubtitle: 'Wpisz kod z aplikacji uwierzytelniającej',
    otpHint: 'Sześć cyfr z aplikacji uwierzytelniającej albo jeden z kodów odzyskiwania',
    otpSubmit: 'Zweryfikuj',
    invalidCredentials: 'Nieprawidłowa nazwa użytkownika lub hasło',
    tooManyAttempts: 'Zbyt wiele prób — odczekaj chwilę i spróbuj ponownie',
    realmUnavailable: 'Realm nie może w tej chwili zweryfikować poświadczeń — store klastra jest nieosiągalny. Zaloguj się jako użytkownik lokalny (break-glass).',
    genericError: 'Logowanie nie powiodło się — czy backend TVirt jest osiągalny?'
  },
  user: {
    logout: 'Wyloguj się',
    password: {
      menu: 'Zmień hasło',
      title: 'Zmiana hasła',
      current: 'Aktualne hasło',
      new: 'Nowe hasło',
      confirm: 'Potwierdź nowe hasło',
      mismatch: 'Hasła nie są zgodne',
      error: 'Nie można zmienić hasła',
      forcedTitle: 'Zmień hasło, aby kontynuować',
      forcedHint: 'To hasło zostało ustawione przez administratora i trzeba je zmienić przed zalogowaniem.',
      forcedSubmit: 'Zmień i zaloguj się'
    },
    mfa: {
      title: 'Uwierzytelnianie dwuskładnikowe',
      subtitle: 'Drugi składnik wymagany przy każdym logowaniu',
      loadError: 'Nie można wczytać stanu drugiego składnika',
      enrolled: 'Aktywne',
      notEnrolled: 'Nieaktywne',
      enrolledAt: 'Aktywowano',
      codesRemaining: 'Pozostałe kody odzyskiwania',
      requiredHint:
        'Administrator wymaga drugiego składnika na tym koncie: skonfiguruj go teraz — do tego czasu logowanie jest możliwe, ale niewiele poza tym.',
      enroll: 'Skonfiguruj',
      enrollTitle: 'Konfiguracja uwierzytelniania dwuskładnikowego',
      enrollHint: 'Zeskanuj ten kod aplikacją uwierzytelniającą, a następnie wpisz pokazany przez nią kod, aby potwierdzić.',
      secretHint: 'Nie da się zeskanować? Wpisz w aplikacji ten sekret:',
      code: 'Kod z aplikacji',
      confirm: 'Potwierdź',
      startError: 'Nie można rozpocząć konfiguracji',
      confirmError: 'Nie można potwierdzić konfiguracji',
      codesTitle: 'Kody odzyskiwania',
      codesWarning:
        'Te kody są pokazywane tylko raz. Zapisz je teraz: każdy z nich pozwala się zalogować, gdy aplikacja uwierzytelniająca jest niedostępna, i działa tylko jeden raz.',
      codesAck: 'Kody odzyskiwania zostały zapisane',
      codesDone: 'Gotowe',
      copy: 'Kopiuj',
      copied: 'Skopiowano',
      download: 'Pobierz',
      regenerate: 'Nowe kody odzyskiwania',
      regenerateTitle: 'Wygeneruj ponownie kody odzyskiwania',
      regenerateHint: 'Wszystkie wydane dotąd kody przestają działać w chwili wygenerowania nowego zestawu.',
      regenerateConfirm: 'Wygeneruj ponownie',
      regenerateError: 'Nie można wygenerować ponownie kodów odzyskiwania',
      remove: 'Wyłącz',
      removeTitle: 'Wyłącz drugi składnik',
      removeConfirm: 'Wyłącz',
      removeHint: 'Konto wraca do samego hasła. Drugi składnik można skonfigurować ponownie w dowolnej chwili.',
      removeRequiredHint:
        'Administrator wymaga drugiego składnika na tym koncie, więc serwer odrzuci wyłączenie — najpierw poproś o zniesienie tego wymogu.',
      removeError: 'Nie można wyłączyć drugiego składnika'
    },
    profile: {
      menu: 'Przejdź do mojego profilu',
      sessions: 'Aktywne sesje',
      sessionsHint: 'Sesje otwarte na tym węźle',
      sessionsEmpty: 'Brak aktywnych sesji',
      sessionCreated: 'Zalogowano',
      sessionExpires: 'Wygasa',
      revoke: 'Unieważnij sesję',
      revokeError: 'Nie można unieważnić sesji',
      loadError: 'Nie można wczytać sesji'
    }
  }
}
